import React from "react";
import { Countdown } from "../Countdown";
import { CtaButton } from "../CtaButton";
const FINAL_PLANS = [{
  emoji: "🍕",
  name: "MEGAPACK 72HS™",
  includes: "6 Tomos + 6 Bonos · Todos los rubros",
  oldPrice: "$65.000",
  price: "$19.999 ARS",
  cta: "→ Quiero mi Megapack 72HS",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy",
  featured: false
}, {
  emoji: "👨‍🍳",
  name: "MEGAPACK 72HS™ MAESTRO PRO ⭐",
  includes: "6 Tomos + 6 Bonos + Kit Escalamiento y Marca Personal",
  oldPrice: "$85.000",
  price: "$27.500 ARS",
  cta: "→ Quiero el Megapack Maestro PRO",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy-pro",
  featured: true
}];
export function FinalCta() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-78" data-mp="2z4y1rhyavqbm">
      <div className="max-w-4xl mx-auto text-center" data-id="element-79" data-mp="341wvw0hyrx9t">
        <h2 className="font-condensed text-2xl sm:text-3xl text-[#e10600] tracking-widest mb-6" data-id="element-80" data-mp="294sxqaadnks">
          ⏰ EL PRECIO CIERRA EN:
        </h2>
        <Countdown data-id="element-81" data-mp="3temrixndekzs" />

        <div className="grid gap-6 md:grid-cols-2 mt-12 text-left items-start" data-id="element-82" data-mp="3tf61ns6s4539">
          {FINAL_PLANS.map(p => <div key={p.name} className={`rounded-2xl p-7 flex flex-col ${p.featured ? "bg-black border-2 border-[#e10600] glow-red" : "bg-black border border-neutral-800"}`} data-id="element-83" data-mp="b39h21y1ckwm">
              <div className="text-4xl mb-2" data-id="element-84" data-mp="3aimyrkmkjdf5">{p.emoji}</div>
              <h3 className="font-display text-xl sm:text-2xl text-white uppercase leading-none" data-id="element-85" data-mp="3ohe70qer24vd">
                {p.name}
              </h3>
              <p className="font-condensed text-lg text-[#e10600] tracking-wide mt-2" data-id="element-86" data-mp="3jjcrgfgj8non">{p.includes}</p>
              <div className="mt-5" data-id="element-87" data-mp="13rx8kf9do6im">
                <span className="text-neutral-500 line-through text-xl" data-id="element-88" data-mp="yrj231nfd4mp">{p.oldPrice}</span>
                <div className="font-display text-4xl sm:text-5xl text-white mt-1" data-id="element-89" data-mp="3sjind7qb8yyh">{p.price}</div>
              </div>
              <div className="mt-6 mt-auto pt-6" data-id="element-90" data-mp="1bwmfmuz7alb">
                <CtaButton href={p.href} variant={p.featured ? "primary" : "dark"} pulse={p.featured} data-id="element-91" data-mp="1eiwbt5ca26p">
                  {p.cta}
                </CtaButton>
              </div>
            </div>)}
        </div>

        <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-8 text-xs sm:text-sm text-neutral-400" data-id="element-92" data-mp="39srhig5j7qou">
          <span data-id="element-93" data-mp="3dtbgzqdkv6e5">🔒 Pago 100% seguro</span>
          <span data-id="element-94" data-mp="3ds0avjwntmjv">⚡ Acceso en 5 minutos</span>
          <span data-id="element-95" data-mp="3isnyrwpldn9v">🛡️ Garantía 7 días</span>
          <span data-id="element-96" data-mp="3irmkzkh6ymog">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </p>
      </div>
    </section>;
}